/**
 * productMessageHelper
 *
 * Platform-agnostic builder for the unified `interactive → product` wire
 * body per docs/prd/chat-queue/appendices/api-request-format.md §5.10.
 *
 * TikTok, Lazada, and Shopee use the same envelope; only
 * `messaging_product` differs. The server's per-platform adapter maps
 * the canonical `action.product_retailer_id` to the platform-native id
 * (TikTok `product_id`, Lazada/Shopee `item_id` — parent only).
 */

import { UnifiedMessageRequest } from '../messageApiClient'

export type ProductSendPlatform = 'tiktok' | 'lazada' | 'shopee'

export function buildProductRequestBody(
  platform: ProductSendPlatform,
  buyerId: string,
  productId: string
): UnifiedMessageRequest {
  return {
    messaging_product: platform,
    to: buyerId,
    type: 'interactive',
    interactive: {
      type: 'product',
      action: {
        product_retailer_id: productId,
      },
    },
  }
}
